import { Grid } from '@mui/material';
import CheckBoxGroupImage from 'assets/icons/form-builder/forms/elements/fields/checkbox-group.svg';
import DateFieldImage from 'assets/icons/form-builder/forms/elements/fields/date.svg';
import MultiSelectDropdownImage from 'assets/icons/form-builder/forms/elements/fields/dropdown-multiselect.svg';
import SelectFieldImage from 'assets/icons/form-builder/forms/elements/fields/dropdown.svg';
import NumberFieldImage from 'assets/icons/form-builder/forms/elements/fields/number.svg';
import RadioGroupImage from 'assets/icons/form-builder/forms/elements/fields/radio-group.svg';
import TextAreaImage from 'assets/icons/form-builder/forms/elements/fields/text-area.svg';
import TextFieldImage from 'assets/icons/form-builder/forms/elements/fields/text-field.svg';
import { useIntl } from 'react-intl';
import NewComponentItem from './NewComponentItem';

const Fields = ({ handleDragStart }: any) => {
  const intl = useIntl();
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Text Field' })}
          type="Text Field"
          icon={<img src={TextFieldImage} alt="text-field" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Text Area' })}
          type="Text Area"
          icon={<img src={TextAreaImage} alt="text-area" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Dropdown' })}
          type="Autocomplete"
          items={[intl.formatMessage({ defaultMessage: 'Client' }), intl.formatMessage({ defaultMessage: 'Provider' })]}
          icon={<img src={SelectFieldImage} alt="select-field" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Dropdown Multiselect' })}
          type="Autocomplete"
          multiple
          icon={<img src={MultiSelectDropdownImage} alt="multiselect-dropdown-field" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Checkbox Group' })}
          type="Checkbox Group"
          icon={<img src={CheckBoxGroupImage} alt="checkbox-group" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Radio Group' })}
          type="Radio Group"
          icon={<img src={RadioGroupImage} alt="radio-group" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Number' })}
          type="Number Field"
          icon={<img src={NumberFieldImage} alt="number-field" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <NewComponentItem
          label={intl.formatMessage({ defaultMessage: 'Date' })}
          type="Date Field"
          icon={<img src={DateFieldImage} alt="date-field" height="50px" width="50px" />}
          handleDragStart={handleDragStart}
        />
      </Grid>
    </Grid>
  );
};

export default Fields;
